
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'ProductRecord',
  data() {
    return {
      record: {},
    }
  },
  computed: {
    ...mapState(['dialogVisible']),
    userInfo() {
      return this.$store.state.userInfo || {}
    },
    isLogin() {
      return !!this.userInfo.email
    },
    isPromocollection() {
      return /\@promocollection.(com\.au|uk)/.test(this.userInfo.email)
    },
  },
  watch: {
    userInfo() {
      if (this.isLogin) {
        this.check()
      }
    },
  },
  mounted() {
    if (this.isLogin) {
      this.check()
    } else {
      setTimeout(() => {
        this.openDialog()
      }, 500)
    }
  },
  methods: {
    ...mapMutations(['openDialog']),
    check() {
      if (this.isPromocollection) {
        this.getData()
      } else {
        // Nuxt.js 2.x 版本中，this.$router.redirect 方法已经被废弃
        this.$router.replace('/')
      }
    },
    async getData() {
      const query = this.$route.query
      let url = '/uk-api/uk/goods/record/?product_code=' + this.$route.params.code
      if (query.version && query.version.length) {
        url += `&version=${query.version}`
      }
      const res = await this.$axios.get(url)
      this.record = res.result || {}
    },
  },
}
